<div class="[&>brn-select>div>hlm-select-trigger>button]:rounded-r-none" hlmButtonGroup>
  <brn-select class="inline-block" (valueChange)="setReferentiel($event)">
    <hlm-select-trigger class="bg-components-background-neutral-main">
      <hlm-select-value>
        <div *brnSelectValue="let value">
          <span>{{ value?.nom ?? 'Tous les référentiels' }}</span>
        </div>
      </hlm-select-value>
    </hlm-select-trigger>
    <hlm-select-content class="!min-w-max">
      <hlm-option [value]="undefined">
        <span>Tous les référentiels</span>
      </hlm-option>
      @for (item of referentiels() | trierPar: 'nom'; track $index) {
        <hlm-option [value]="item">
          <span>{{ item.nom }}</span>
        </hlm-option>
      }
    </hlm-select-content>
  </brn-select>
  <div hlmInputGroup>
    <input
      [(ngModel)]="filtre"
      [ngModelOptions]="{ standalone: true }"
      [placeholder]="placeholder()"
      (keydown.enter)="filtrer()"
      hlmInputGroupInput
    />
    <div hlmInputGroupAddon align="inline-end">
      @if (filtre()) {
        <ng-icon class="cursor-pointer" (click)="emptyFilter()" hlm name="lucideX" />
      } @else {
        <ng-icon name="lucideSearch" hlm size="xs" />
      }
    </div>
  </div>
</div>
